/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_SubcategoryInputs */



/**
* | output |
* | --- |
* | "Subcategory" |
*
* @param {Sanction_SubcategoryInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_subcategory = /** @type {((inputs?: Sanction_SubcategoryInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_SubcategoryInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sous-catégorie")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subcategoría")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Subcategoria")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottocategoria")
	return /** @type {LocalizedString} */ ("Subcategory")
});